import { render, staticRenderFns } from "./changePkgGroup.vue?vue&type=template&id=20d0c6fa&scoped=true&"
import script from "./changePkgGroup.vue?vue&type=script&lang=js&"
export * from "./changePkgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0c6fa",
  null
  
)

export default component.exports